import React from 'react';
import { Button, Modal, Form, InputGroup } from 'react-bootstrap';
import TreeView from '../../treeView';
import { SearchIcon } from '../../ui/icons';
import { useAssignDevices } from './useAssignDevices'
import useHandleGroupSearch from '../../../pages/deviceManagement/useHandleGroupSearch';
import useDeviceManagement from '../../../pages/deviceManagement/useDeviceManagement';
import { IAssignDevice } from '../../../common/types/devicesTypes';

const AssignDevices = ({ devices, setDeviceArray, setSelectedRows, showModel, handleClose, setAssignSuccessfully }: { devices: IAssignDevice[], setDeviceArray?: React.Dispatch<React.SetStateAction<IAssignDevice[]>>, setSelectedRows?: React.Dispatch<React.SetStateAction<[]>>, showModel: boolean, handleClose: () => void, setAssignSuccessfully: React.Dispatch<React.SetStateAction<boolean>> }) => {

  const {
    handleGroupInputChange,
    groupSearchQuery,
    nodesToDisplay
  } = useHandleGroupSearch({ isEditable: false });


  const { handleAssignButtonClick, handleDataFromTreeView, selectGroupState, setSelectGroupState, closeAssignDevice } = useAssignDevices(devices, setDeviceArray, setSelectedRows, handleClose, setAssignSuccessfully);

  return (
    <>

      <Modal show={showModel} onHide={closeAssignDevice} className='modal-container move-device-modal' centered>
        <Modal.Header closeButton>
          <Modal.Title>Assign Device</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='add-device-container'>
            <div className="row">
              <div className="col-md-5">
                <div className="device-selected-content">
                  <h3>{Array.isArray(devices)
                    ? `${devices.length} Device${devices.length !== 1 ? 's' : ''} Selected`
                    : 'No Devices Selected'
                  }</h3>
                  <ul>
                    {Array.isArray(devices) && devices.map(device => (
                      <li key={device["deviceDisplayName"]}>{device["deviceDisplayName"]}</li>
                    ))}
                  </ul>
                </div>

              </div>
              <div className="col-md-1">
                <div className="border-line-container"></div>
              </div>
              <div className="col-md-6">
                <div className="move-device-group-container">
                  <h2>Assign Device(s) to Group:</h2>
                  <div className="assign-roles-tree-container">
                    <div className="assign-roles-search">
                      <InputGroup>
                        <Form.Control
                          placeholder="Search"
                          aria-label="Search"
                          aria-describedby="search-tree-list"
                          value={groupSearchQuery}
                          onChange={handleGroupInputChange}
                        />
                        <InputGroup.Text id="alert-search-input"><SearchIcon /></InputGroup.Text>
                      </InputGroup>
                    </div>
                    <div className="assign-roles-tree device-managment-checkbox-tree">
                      <TreeView nodes={nodesToDisplay} onDataFromTreeView={handleDataFromTreeView} isModalOrg={true}
                        isMultiSelect={true}
                        selectGroupState={selectGroupState}
                        setSelectGroupState={setSelectGroupState}
                        isSelectAllEnabled={true}></TreeView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={closeAssignDevice}>
            Cancel
          </Button>
          <Button className='btn-style' onClick={handleAssignButtonClick} disabled={!selectGroupState?.groups?.length}>
            Assign
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AssignDevices;